export default __webpack_public_path__ + "static/Biometric-Security-fa8b1b76eb12d9e7ad13a2084a97a40c.webp";